module.exports = __webpack_public_path__ + "static/media/trial2_4.ad24fa60.png";